module.exports = __webpack_public_path__ + "img/ic_bed_heat4.42bb1d10.png";